import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="py-14 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="mb-10 md:mb-14">
            <div className="w-full max-w-2xl mx-auto rounded-2xl overflow-hidden mb-10">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20artistic%20illustration%2C%20beautiful%20abstract%20composition%20with%20flowing%20ink%20and%20warm%20coral%20tones%2C%20elegant%20book%20pages%20floating%20with%20soft%20golden%20light%2C%20dreamy%20atmosphere%2C%20clean%20gradient%20background%2C%20no%20text%2C%20minimalist%20poetic%20style%2C%20high%20quality%20digital%20art&width=1200&height=600&seq=cta-banner&orientation=landscape"
                alt="开始您的韩漫阅读之旅"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <p className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-950 leading-relaxed mb-6 max-w-xl mx-auto">
              每一个<em className="not-italic font-light text-foreground-400">精彩故事</em>，都值得被<strong className="font-bold">认真阅读</strong>
            </p>
          </div>

          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 bg-foreground-950 hover:bg-foreground-900 text-white font-medium px-8 py-4 rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer"
          >
            立即开始免费阅读
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}